module.exports = __webpack_public_path__ + "img/highSpeedRail-2.ec7528b5.jpg";